import { render, staticRenderFns } from "./NewAccountSettingGroup.vue?vue&type=template&id=3db1453e&scoped=true&"
import script from "./NewAccountSettingGroup.vue?vue&type=script&lang=js&"
export * from "./NewAccountSettingGroup.vue?vue&type=script&lang=js&"
import style0 from "./NewAccountSettingGroup.vue?vue&type=style&index=0&id=3db1453e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db1453e",
  null
  
)

export default component.exports